import type { AnchorHTMLAttributes } from 'react'
import { navigate } from '@/lib/navigation'

interface LinkProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
  href: string
}

export default function Link({ href, onClick, children, target, ...props }: LinkProps) {
  const isInternal = href.startsWith('/') && !href.startsWith('//')

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (onClick) onClick(e)
    if (e.defaultPrevented) return
    if (!isInternal) return
    if (target && target !== '_self') return
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return
    if (e.button !== 0) return
    e.preventDefault()
    navigate(href)
  }

  return (
    <a href={href} onClick={handleClick} target={target} {...props}>
      {children}
    </a>
  )
}
